import { ContextColumnId } from "components/Environment/constants/contextTable";
import { TableContext } from "components/Table/Context";
import TableBodyRow from "ds/components/Table/Row";
import TableCell from "ds/components/Table/Row/Cell";
import useTypedContext from "hooks/useTypedContext";
import { StackContextAttachment } from "types/generated";

import ContextDescriptionCell from "../Cells/ContextDescriptionCell";
import ContextNameCell from "../Cells/ContextNameCell";

type ContextsRowProps = {
  context: StackContextAttachment;
};

const CELLS = {
  [ContextColumnId.NAME]: ContextNameCell,
  [ContextColumnId.DESCRIPTION]: ContextDescriptionCell,
};

const ContextsRow = ({ context }: ContextsRowProps) => {
  const { visibleColumnIds } = useTypedContext(TableContext);

  if (!context) {
    return null;
  }

  return (
    <TableBodyRow>
      {visibleColumnIds.map((id) => {
        const Component = CELLS[id as ContextColumnId];
        const uniqueKey = `${id}-${context.id}`;
        return (
          <TableCell key={uniqueKey} id={id}>
            <Component context={context} />
          </TableCell>
        );
      })}
    </TableBodyRow>
  );
};

export default ContextsRow;
